import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from './context/context';
import { SpeechProvider } from '@speechly/react-client';
import App from './App'
import './index.css';
ReactDOM.render(
    <SpeechProvider appId='187fa4ec-b285-40fc-817e-f842bf96e2a8' language='en-US'>
<Provider>
<App/>
</Provider>
</SpeechProvider>,
document.getElementById('root'));